import { queryParams, type RouteQueryOptions, type RouteDefinition } from './../../../../../wayfinder'
/**
* @see \App\Http\Controllers\Export\GenerateExportController::__invoke
* @see app/Http/Controllers/Export/GenerateExportController.php
* @route '/api/export/generate'
*/
const GenerateExportController = (options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: GenerateExportController.url(options),
    method: 'post',
})

GenerateExportController.definition = {
    methods: ["post"],
    url: '/api/export/generate',
} satisfies RouteDefinition<["post"]>

/**
* @see \App\Http\Controllers\Export\GenerateExportController::__invoke
* @see app/Http/Controllers/Export/GenerateExportController.php
* @route '/api/export/generate'
*/
GenerateExportController.url = (options?: RouteQueryOptions) => {
    return GenerateExportController.definition.url + queryParams(options)
}

/**
* @see \App\Http\Controllers\Export\GenerateExportController::__invoke
* @see app/Http/Controllers/Export/GenerateExportController.php
* @route '/api/export/generate'
*/
GenerateExportController.post = (options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: GenerateExportController.url(options),
    method: 'post',
})

export default GenerateExportController